import React from 'react';

const PythonIcon = ({ conditionalFillColor, width = "55", height = "55", ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 164 164"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g fill={conditionalFillColor} stroke="none">
      <path d="M82 164C127.287 164 164 127.287 164 82C164 36.7126 127.287 0 82 0C36.7126 0 0 36.7126 0 82C0 127.287 36.7126 164 82 164Z" />
      <path
        d="M81.1782 38C58.5847 38 59.9936 47.7317 59.9936 47.7317L60.0109 57.8264H81.5783V60.8513H51.4536C51.4536 60.8513 37 59.2265 37 81.8876C37 104.549 49.6273 103.736 49.6273 103.736H57.1585V93.2269C57.1585 93.2269 56.7585 80.6777 69.5771 80.6777H90.9705C90.9705 80.6777 102.989 80.8678 102.989 69.131V49.7368C102.989 49.7368 104.798 38 81.1782 38ZM69.2988 44.7932C71.4381 44.7932 73.1774 46.5217 73.1774 48.6478C73.1774 50.7739 71.4381 52.5025 69.2988 52.5025C67.1595 52.5025 65.4202 50.7739 65.4202 48.6478C65.4202 46.5217 67.1421 44.7932 69.2988 44.7932ZM81.8218 126C104.415 126 103.006 116.268 103.006 116.268L102.989 106.174H81.4217V103.149H111.546C111.546 103.149 126 104.774 126 82.1124C126 59.4512 113.373 60.2636 113.373 60.2636H105.842V70.7731C105.842 70.7731 106.242 83.3223 93.4229 83.3223H72.0295C72.0295 83.3223 60.0109 83.1322 60.0109 94.869V114.263C60.0109 114.263 58.2195 126 81.8218 126ZM93.7186 119.207C91.5792 119.207 89.8399 117.478 89.8399 115.352C89.8399 113.226 91.5792 111.498 93.7186 111.498C95.8579 111.498 97.5972 113.226 97.5972 115.352C97.5972 117.496 95.8579 119.207 93.7186 119.207Z"
        fill="white"
      />
    </g>
  </svg>
);

export default PythonIcon;